import { location } from 'cdui-js';
import AddressInfo from './AddressInfo';
import SelectOverseasId from './SelectOverseasId';
import UploadOverseasLic from './UploadOverseasLic';
import { resetVirtualApplyState, virtualApplyState } from './store';
import { addAccState } from '../store';

const AddVirtualApplyInfo = () => {
  const busIdFromQuery = (location.query.busId as string) || '';
  const keepBusId = busIdFromQuery || virtualApplyState.busId || addAccState.busId;

  // BACK 续办：保留 hydrate 结果，勿 reset
  if (addAccState.virtualResume) {
    addAccState.virtualResume = false;
    if (!virtualApplyState.busId && keepBusId) {
      virtualApplyState.busId = keepBusId;
    }
  } else {
    resetVirtualApplyState();
    virtualApplyState.step = 1;
    virtualApplyState.busId = keepBusId;
  }

  return (
    <div>
      {virtualApplyState.step === 1 ? (
        <SelectOverseasId />
      ) : virtualApplyState.step === 2 ? (
        <UploadOverseasLic />
      ) : virtualApplyState.step === 3 ? (
        <AddressInfo />
      ) : null}
    </div>
  );
};

export default AddVirtualApplyInfo;
